<ftr-badge [color]="badgeColor" [text]="mfaStatus"></ftr-badge>
